import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {homeRoute} from './main/home/home.routes';
import {profileRoute} from './main/profile/profile.routes';
import {error401Route} from './main/error-pages/401/error-401.routes';
import {error404Route} from './main/error-pages/404/error-404.routes';
import {error503Route} from './main/error-pages/503/error-503.routes';

const appRoutes: Routes = [
    homeRoute,
    profileRoute,
    error401Route,
    error404Route,
    error503Route,
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: '**',
        redirectTo: '404'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {useHash: true})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}